import { render, staticRenderFns } from "./DashboardPedidos.vue?vue&type=template&id=7acaf131&scoped=true&lang=pug"
import script from "./DashboardPedidos.vue?vue&type=script&lang=js"
export * from "./DashboardPedidos.vue?vue&type=script&lang=js"
import style0 from "./DashboardPedidos.vue?vue&type=style&index=0&id=7acaf131&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acaf131",
  null
  
)

export default component.exports